import { type ReduxUser, type ProgramRedux } from 'models';

export const canRateProgramObject = ({ viewer, program }: { viewer: ReduxUser; program?: ProgramRedux }) =>
  Boolean(program?.id) &&
  !viewer.superadmin &&
  !viewer.admin_programs.includes(program?.id ?? '') &&
  !viewer.author_programs.includes(program?.id ?? '');
